export default "__VITE_ASSET__D8L8skSA__"